var map = {
	"../user/user-profile/user-profile.module": [
		"./src/app/pages/user/user-profile/user-profile.module.ts",
		"common",
		"user-profile.module.0"
	],
	"./../../pages/reset-password/reset-password.module": [
		"./src/app/pages/reset-password/reset-password.module.ts",
		"common",
		"reset-password.module"
	],
	"./accordion/accordion.module": [
		"./src/app/theme/ui-elements/basic/accordion/accordion.module.ts",
		"accordion.module"
	],
	"./add-on/add-on.module": [
		"./src/app/theme/forms/add-on/add-on.module.ts",
		"common",
		"add-on.module"
	],
	"./advance-elements/advance-elements.module": [
		"./src/app/theme/forms/advance-elements/advance-elements.module.ts",
		"common",
		"advance-elements.module"
	],
	"./alert/alert.module": [
		"./src/app/theme/ui-elements/basic/alert/alert.module.ts",
		"common",
		"alert.module"
	],
	"./analytics/analytics.module": [
		"./src/app/theme/dashboard/analytics/analytics.module.ts",
		"common",
		"analytics.module"
	],
	"./basic-color/basic-color.module": [
		"./src/app/theme/ui-elements/basic/basic-color/basic-color.module.ts",
		"basic-color.module"
	],
	"./basic-elements/basic-elements.module": [
		"./src/app/theme/forms/basic-elements/basic-elements.module.ts",
		"basic-elements.module"
	],
	"./basic-invoice/basic-invoice.module": [
		"./src/app/theme/extension/invoice/basic-invoice/basic-invoice.module.ts",
		"basic-invoice.module"
	],
	"./basic-list/basic-list.module": [
		"./src/app/theme/ui-elements/basic/basic-list/basic-list.module.ts",
		"common",
		"basic-list.module"
	],
	"./basic-login/basic-login.module": [
		"./src/app/theme/auth/login/basic-login/basic-login.module.ts",
		"common",
		"basic-login.module"
	],
	"./basic-other/basic-other.module": [
		"./src/app/theme/ui-elements/basic/basic-other/basic-other.module.ts",
		"basic-other.module"
	],
	"./basic-reg/basic-reg.module": [
		"./src/app/theme/auth/registration/basic-reg/basic-reg.module.ts",
		"basic-reg.module"
	],
	"./border/border.module": [
		"./src/app/theme/table/bootstrap-table/border/border.module.ts",
		"border.module"
	],
	"./box-shadow/box-shadow.module": [
		"./src/app/theme/ui-elements/basic/box-shadow/box-shadow.module.ts",
		"box-shadow.module"
	],
	"./breadcrumb/breadcrumb.module": [
		"./src/app/theme/ui-elements/basic/breadcrumb/breadcrumb.module.ts",
		"common",
		"breadcrumb.module"
	],
	"./button/button.module": [
		"./src/app/theme/ui-elements/basic/button/button.module.ts",
		"common",
		"button.module"
	],
	"./carousel/carousel.module": [
		"./src/app/theme/ui-elements/advance/carousel/carousel.module.ts",
		"common",
		"carousel.module"
	],
	"./chart-widget/chart-widget.module": [
		"./src/app/theme/widget/chart-widget/chart-widget.module.ts",
		"common",
		"chart-widget.module"
	],
	"./customer-detail/customer-detail.module": [
		"./src/app/pages/customer/customer-detail/customer-detail.module.ts",
		"common",
		"customer-detail.module"
	],
	"./customer-group-detail/customer-group-detail.module": [
		"./src/app/pages/customer-group/customer-group-detail/customer-group-detail.module.ts",
		"customer-group-detail.module"
	],
	"./customer-group-list/customer-group-list.module": [
		"./src/app/pages/customer-group/customer-group-list/customer-group-list.module.ts",
		"customer-group-list.module"
	],
	"./customer-group-manage/customer-group-manage.module": [
		"./src/app/pages/customer-group/customer-group-manage/customer-group-manage.module.ts",
		"customer-group-manage.module"
	],
	"./customer-list/customer-list.module": [
		"./src/app/pages/customer/customer-list/customer-list.module.ts",
		"common",
		"customer-list.module"
	],
	"./customer-manage/customer-manage.module": [
		"./src/app/pages/customer/customer-manage/customer-manage.module.ts",
		"common",
		"customer-manage.module"
	],
	"./data-widget/data-widget.module": [
		"./src/app/theme/widget/data-widget/data-widget.module.ts",
		"data-widget.module"
	],
	"./default/default.module": [
		"./src/app/theme/dashboard/default/default.module.ts",
		"common",
		"default.module"
	],
	"./disposal-process-detail/disposal-process-detail.module": [
		"./src/app/pages/disposal-process/disposal-process-detail/disposal-process-detail.module.ts",
		"common",
		"disposal-process-detail.module"
	],
	"./disposal-process-list/disposal-process-list.module": [
		"./src/app/pages/disposal-process/disposal-process-list/disposal-process-list.module.ts",
		"common",
		"disposal-process-list.module"
	],
	"./disposal-process-manage/disposal-process-manage.module": [
		"./src/app/pages/disposal-process/disposal-process-manage/disposal-process-manage.module.ts",
		"common",
		"disposal-process-manage.module"
	],
	"./ecommerce/ecommerce.module": [
		"./src/app/theme/dashboard/ecommerce/ecommerce.module.ts",
		"common",
		"ecommerce.module"
	],
	"./forgot/forgot.module": [
		"./src/app/theme/auth/forgot/forgot.module.ts",
		"common",
		"forgot.module"
	],
	"./form-picker/form-picker.module": [
		"./src/app/theme/forms/form-picker/form-picker.module.ts",
		"common",
		"form-picker.module"
	],
	"./form-select/form-select.module": [
		"./src/app/theme/forms/form-select/form-select.module.ts",
		"common",
		"form-select.module"
	],
	"./form-validation/form-validation.module": [
		"./src/app/theme/forms/form-validation/form-validation.module.ts",
		"common",
		"form-validation.module"
	],
	"./generic-class/generic-class.module": [
		"./src/app/theme/ui-elements/basic/generic-class/generic-class.module.ts",
		"generic-class.module"
	],
	"./group-permission-list/group-permission-list.module": [
		"./src/app/pages/group-permission/group-permission-list/group-permission-list.module.ts",
		"common",
		"group-permission-list.module"
	],
	"./group-permission-manage/group-permission-manage.module": [
		"./src/app/pages/group-permission/group-permission-manage/group-permission-manage.module.ts",
		"common",
		"group-permission-manage.module"
	],
	"./header-footer-login/header-footer-login.module": [
		"./src/app/theme/auth/login/header-footer-login/header-footer-login.module.ts",
		"header-footer-login.module"
	],
	"./header-footer-reg/header-footer-reg.module": [
		"./src/app/theme/auth/registration/header-footer-reg/header-footer-reg.module.ts",
		"header-footer-reg.module"
	],
	"./invoice-list/invoice-list.module": [
		"./src/app/theme/extension/invoice/invoice-list/invoice-list.module.ts",
		"common",
		"invoice-list.module"
	],
	"./invoice-summary/invoice-summary.module": [
		"./src/app/theme/extension/invoice/invoice-summary/invoice-summary.module.ts",
		"common",
		"invoice-summary.module"
	],
	"./label-badge/label-badge.module": [
		"./src/app/theme/ui-elements/basic/label-badge/label-badge.module.ts",
		"common",
		"label-badge.module"
	],
	"./lock-screen/lock-screen.module": [
		"./src/app/theme/auth/lock-screen/lock-screen.module.ts",
		"lock-screen.module"
	],
	"./login-history/login-history.module": [
		"./src/app/pages/user/login-history/login-history.module.ts",
		"common",
		"login-history.module"
	],
	"./login/login.module": [
		"./src/app/theme/auth/login/login.module.ts",
		"login.module"
	],
	"./modal/modal.module": [
		"./src/app/theme/ui-elements/advance/modal/modal.module.ts",
		"common",
		"modal.module"
	],
	"./notification/notification.module": [
		"./src/app/theme/ui-elements/advance/notification/notification.module.ts",
		"notification.module"
	],
	"./notify/notify.module": [
		"./src/app/theme/ui-elements/advance/notify/notify.module.ts",
		"common",
		"notify.module"
	],
	"./pages/customer-group/customer-group.module": [
		"./src/app/pages/customer-group/customer-group.module.ts",
		"customer-group.module"
	],
	"./pages/customer/customer.module": [
		"./src/app/pages/customer/customer.module.ts",
		"customer.module"
	],
	"./pages/disposal-process/disposal-process.module": [
		"./src/app/pages/disposal-process/disposal-process.module.ts",
		"disposal-process.module"
	],
	"./pages/group-permission/group-permission.module": [
		"./src/app/pages/group-permission/group-permission.module.ts",
		"group-permission.module"
	],
	"./pages/product/product.module": [
		"./src/app/pages/product/product.module.ts",
		"product.module"
	],
	"./pages/quotation-approval/quotation-approval.module": [
		"./src/app/pages/quotation-approval/quotation-approval.module.ts",
		"quotation-approval.module"
	],
	"./pages/quotation/quotation.module": [
		"./src/app/pages/quotation/quotation.module.ts",
		"quotation.module"
	],
	"./pages/transportation/transportation.module": [
		"./src/app/pages/transportation/transportation.module.ts",
		"transportation.module"
	],
	"./pages/user/user.module": [
		"./src/app/pages/user/user.module.ts",
		"user.module.0"
	],
	"./paging/paging.module": [
		"./src/app/theme/table/data-table/paging/paging.module.ts",
		"common",
		"paging.module"
	],
	"./pre-loader/pre-loader.module": [
		"./src/app/theme/ui-elements/basic/pre-loader/pre-loader.module.ts",
		"pre-loader.module"
	],
	"./product-detail/product-detail.module": [
		"./src/app/pages/product/product-detail/product-detail.module.ts",
		"common",
		"product-detail.module"
	],
	"./product-list/product-list.module": [
		"./src/app/pages/product/product-list/product-list.module.ts",
		"common",
		"product-list.module"
	],
	"./product-manage/product-manage.module": [
		"./src/app/pages/product/product-manage/product-manage.module.ts",
		"common",
		"product-manage.module"
	],
	"./progressbar/progressbar.module": [
		"./src/app/theme/ui-elements/basic/progressbar/progressbar.module.ts",
		"progressbar.module"
	],
	"./quotation-approval-detail/quotation-approval-detail.module": [
		"./src/app/pages/quotation-approval/quotation-approval-detail/quotation-approval-detail.module.ts",
		"common",
		"quotation-approval-detail.module"
	],
	"./quotation-approval-list/quotation-approval-list.module": [
		"./src/app/pages/quotation-approval/quotation-approval-list/quotation-approval-list.module.ts",
		"common",
		"quotation-approval-list.module"
	],
	"./quotation-approval-manage/quotation-approval-manage.module": [
		"./src/app/pages/quotation-approval/quotation-approval-manage/quotation-approval-manage.module.ts",
		"quotation-approval-manage.module"
	],
	"./quotation-detail/quotation-detail.module": [
		"./src/app/pages/quotation/quotation-detail/quotation-detail.module.ts",
		"common",
		"quotation-detail.module"
	],
	"./quotation-list/quotation-list.module": [
		"./src/app/pages/quotation/quotation-list/quotation-list.module.ts",
		"common",
		"quotation-list.module"
	],
	"./quotation-manage/quotation-manage.module": [
		"./src/app/pages/quotation/quotation-manage/quotation-manage.module.ts",
		"common",
		"quotation-manage.module"
	],
	"./rating/rating.module": [
		"./src/app/theme/ui-elements/advance/rating/rating.module.ts",
		"rating.module"
	],
	"./registration/registration.module": [
		"./src/app/theme/auth/registration/registration.module.ts",
		"registration.module"
	],
	"./row-details/row-details.module": [
		"./src/app/theme/table/data-table/row-details/row-details.module.ts",
		"common",
		"row-details.module"
	],
	"./selection/selection.module": [
		"./src/app/theme/table/data-table/selection/selection.module.ts",
		"common",
		"selection.module"
	],
	"./sizing/sizing.module": [
		"./src/app/theme/table/bootstrap-table/sizing/sizing.module.ts",
		"sizing.module"
	],
	"./social-header-footer-login/social-header-footer-login.module": [
		"./src/app/theme/auth/login/social-header-footer-login/social-header-footer-login.module.ts",
		"social-header-footer-login.module"
	],
	"./social-header-footer-reg/social-header-footer-reg.module": [
		"./src/app/theme/auth/registration/social-header-footer-reg/social-header-footer-reg.module.ts",
		"social-header-footer-reg.module"
	],
	"./social-login/social-login.module": [
		"./src/app/theme/auth/login/social-login/social-login.module.ts",
		"social-login.module"
	],
	"./social-reg/social-reg.module": [
		"./src/app/theme/auth/registration/social-reg/social-reg.module.ts",
		"social-reg.module"
	],
	"./statistic/statistic.module": [
		"./src/app/theme/widget/statistic/statistic.module.ts",
		"common",
		"statistic.module"
	],
	"./styling/styling.module": [
		"./src/app/theme/table/bootstrap-table/styling/styling.module.ts",
		"styling.module"
	],
	"./table-basic-data/table-basic-data.module": [
		"./src/app/theme/table/data-table/table-basic-data/table-basic-data.module.ts",
		"common",
		"table-basic-data.module"
	],
	"./table-basic/table-basic.module": [
		"./src/app/theme/table/bootstrap-table/table-basic/table-basic.module.ts",
		"table-basic.module"
	],
	"./table-edit/table-edit.module": [
		"./src/app/theme/table/data-table/table-edit/table-edit.module.ts",
		"common",
		"table-edit.module"
	],
	"./tabs/tabs.module": [
		"./src/app/theme/ui-elements/basic/tabs/tabs.module.ts",
		"common",
		"tabs.module"
	],
	"./task-board/task-board.module": [
		"./src/app/theme/task/task-board/task-board.module.ts",
		"common",
		"task-board.module"
	],
	"./task-details/task-details.module": [
		"./src/app/theme/task/task-details/task-details.module.ts",
		"common",
		"task-details.module"
	],
	"./task-issue/task-issue.module": [
		"./src/app/theme/task/task-issue/task-issue.module.ts",
		"common",
		"task-issue.module"
	],
	"./task-list/task-list.module": [
		"./src/app/theme/task/task-list/task-list.module.ts",
		"common",
		"task-list.module"
	],
	"./theme/auth/auth.module": [
		"./src/app/theme/auth/auth.module.ts",
		"auth.module"
	],
	"./theme/dashboard/dashboard.module": [
		"./src/app/theme/dashboard/dashboard.module.ts",
		"dashboard.module"
	],
	"./theme/extension/invoice/invoice.module": [
		"./src/app/theme/extension/invoice/invoice.module.ts",
		"invoice.module"
	],
	"./theme/forms/forms.module": [
		"./src/app/theme/forms/forms.module.ts",
		"forms.module"
	],
	"./theme/maintenance/coming-soon/coming-soon.module": [
		"./src/app/theme/maintenance/coming-soon/coming-soon.module.ts",
		"coming-soon.module"
	],
	"./theme/maintenance/error/error.module": [
		"./src/app/theme/maintenance/error/error.module.ts",
		"error.module"
	],
	"./theme/maintenance/offline-ui/offline-ui.module": [
		"./src/app/theme/maintenance/offline-ui/offline-ui.module.ts",
		"offline-ui.module"
	],
	"./theme/navigation/navigation.module": [
		"./src/app/theme/navigation/navigation.module.ts",
		"navigation.module"
	],
	"./theme/simple-page/simple-page.module": [
		"./src/app/theme/simple-page/simple-page.module.ts",
		"simple-page.module"
	],
	"./theme/table/bootstrap-table/bootstrap-table.module": [
		"./src/app/theme/table/bootstrap-table/bootstrap-table.module.ts",
		"bootstrap-table.module"
	],
	"./theme/table/data-table/data-table.module": [
		"./src/app/theme/table/data-table/data-table.module.ts",
		"data-table.module"
	],
	"./theme/task/task.module": [
		"./src/app/theme/task/task.module.ts",
		"task.module"
	],
	"./theme/ui-elements/advance/advance.module": [
		"./src/app/theme/ui-elements/advance/advance.module.ts",
		"advance.module"
	],
	"./theme/ui-elements/animation/animation.module": [
		"./src/app/theme/ui-elements/animation/animation.module.ts",
		"animation.module"
	],
	"./theme/ui-elements/basic/basic.module": [
		"./src/app/theme/ui-elements/basic/basic.module.ts",
		"basic.module"
	],
	"./theme/user/user.module": [
		"./src/app/theme/user/user.module.ts",
		"user.module"
	],
	"./theme/widget/widget.module": [
		"./src/app/theme/widget/widget.module.ts",
		"widget.module"
	],
	"./tooltip/tooltip.module": [
		"./src/app/theme/ui-elements/basic/tooltip/tooltip.module.ts",
		"common",
		"tooltip.module"
	],
	"./transportation-detail/transportation-detail.module": [
		"./src/app/pages/transportation/transportation-detail/transportation-detail.module.ts",
		"common",
		"transportation-detail.module"
	],
	"./transportation-list/transportation-list.module": [
		"./src/app/pages/transportation/transportation-list/transportation-list.module.ts",
		"common",
		"transportation-list.module"
	],
	"./transportation-manage/transportation-manage.module": [
		"./src/app/pages/transportation/transportation-manage/transportation-manage.module.ts",
		"common",
		"transportation-manage.module"
	],
	"./typography/typography.module": [
		"./src/app/theme/ui-elements/basic/typography/typography.module.ts",
		"common",
		"typography.module"
	],
	"./user-approval/user-approval.module": [
		"./src/app/pages/user/user-approval/user-approval.module.ts",
		"common",
		"user-approval.module"
	],
	"./user-card/user-card.module": [
		"./src/app/theme/user/user-card/user-card.module.ts",
		"common",
		"user-card.module"
	],
	"./user-detail/user-detail.module": [
		"./src/app/pages/user/user-detail/user-detail.module.ts",
		"common",
		"user-detail.module"
	],
	"./user-list/user-list.module": [
		"./src/app/pages/user/user-list/user-list.module.ts",
		"common",
		"user-list.module"
	],
	"./user-manage/user-manage.module": [
		"./src/app/pages/user/user-manage/user-manage.module.ts",
		"common",
		"user-manage.module"
	],
	"./user-profile/user-profile.module": [
		"./src/app/theme/user/user-profile/user-profile.module.ts",
		"common",
		"user-profile.module"
	]
};
function webpackAsyncContext(req) {
	var ids = map[req];
	if(!ids)
		return Promise.reject(new Error("Cannot find module '" + req + "'."));
	return Promise.all(ids.slice(1).map(__webpack_require__.e)).then(function() {
		return __webpack_require__(ids[0]);
	});
};
webpackAsyncContext.keys = function webpackAsyncContextKeys() {
	return Object.keys(map);
};
webpackAsyncContext.id = "./src/$$_lazy_route_resource lazy recursive";
module.exports = webpackAsyncContext;


//////////////////
// WEBPACK FOOTER
// ./src/$$_lazy_route_resource lazy
// module id = ./src/$$_lazy_route_resource lazy recursive
// module chunks = main